import { FilterKeyTypes } from "../../shared/types/FilterKeys.types";
import { SESSION_CONSTANT } from "../../shared/utils/SessionConstants";
import { ModuleFeatureKey } from "../../shared/utils/ModuleFeatureKeyConstants";

export const setFilteredKeys = (filteredKeys:FilterKeyTypes) => {
  localStorage.setItem(SESSION_CONSTANT.FILTER_KEY, JSON.stringify(filteredKeys));
};
export const getFilteredKeys = (): FilterKeyTypes => {
  const storedFilterKeys = localStorage.getItem(SESSION_CONSTANT.FILTER_KEY);
  return storedFilterKeys ? JSON.parse(storedFilterKeys) : null;
};
export const getFeatureKeys = () => {
  return JSON.parse(localStorage.getItem(SESSION_CONSTANT.FEATURES_KEY) ?? "[]");
};

export const getAuthToken = () => {
  return localStorage.getItem(SESSION_CONSTANT.TOKEN_KEY);
};
export const hasDeliverableCreatePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.DELIVERABLE_CREATE);
};
export const hasExternalK1UploadPermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.EXTERNAL_K1_UPLOAD);
};
export const hasCoaCreatePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.COA_CREATE);
};

export const hasTemplateCreatePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.TEMPLATE_CREATE);
};

export const hasImportTemplatePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.RULE_ENGINE_TEMPLATE_UPLOAD);
};

export const hasExportTemplatePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.RULE_ENGINE_TEMPLATE_EXPORT);
};

export const hasDeliverableViewPermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.DELIVERABLE_VIEW);
};
export const hasTaxFormAdminPermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.TAX_FORM_ADMIN);
};
// K-2 and K-3 downloads and the K-1 engine routes. The BackEnd checks K1_GENERATE there; TAX_FORM_ADMIN now only gates tax form and line management.
export const hasK1GeneratePermission = () => {
  return getFeatureKeys().includes(ModuleFeatureKey.K1_GENERATE);
};
